export default __webpack_public_path__ + "static/media/Photo 8 - MR - Absence jalousie.788be2cc.png";